import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  FaArrowLeft,
  FaCheckCircle,
  FaFileContract,
  FaShieldAlt,
  FaUserCheck,
  FaHandshake,
  FaExclamationTriangle,
  FaSyncAlt,
} from "react-icons/fa";

const styles = `
  :root {
    --legal-primary: #ff5f91;
    --legal-primary-dark: #ea477d;
    --legal-light: #fff0f5;
    --legal-dark: #25182f;
    --legal-text: #625967;
    --legal-border: #f0e5eb;
    --legal-white: #ffffff;
  }

  * {
    box-sizing: border-box;
  }

  body {
    margin: 0;
    background: #fff8fb;
  }

  .terms-page {
    min-height: 100vh;
    padding-bottom: 60px;
    color: var(--legal-dark);
    background:
      radial-gradient(
        circle at 100% 0%,
        rgba(255, 95, 145, 0.14),
        transparent 30%
      ),
      linear-gradient(180deg, #fff 0%, #fff8fb 100%);
    font-family: Arial, Helvetica, sans-serif;
  }

  .terms-header {
    position: sticky;
    top: 0;
    z-index: 100;
    background: rgba(255, 255, 255, 0.96);
    border-bottom: 1px solid var(--legal-border);
    backdrop-filter: blur(14px);
  }

  .terms-header-content {
    width: min(1100px, calc(100% - 40px));
    min-height: 72px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
  }

  .terms-brand {
    display: flex;
    align-items: center;
    gap: 11px;
    color: var(--legal-dark);
    text-decoration: none;
    font-size: 21px;
    font-weight: 800;
  }

  .terms-brand-icon {
    width: 42px;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    background: linear-gradient(
      135deg,
      var(--legal-primary),
      var(--legal-primary-dark)
    );
    border-radius: 14px;
    box-shadow: 0 8px 20px rgba(255, 95, 145, 0.25);
  }

  .terms-brand span span {
    color: var(--legal-primary);
  }

  .terms-language {
    display: flex;
    align-items: center;
    padding: 4px;
    background: var(--legal-light);
    border-radius: 999px;
  }

  .terms-language button {
    width: 42px;
    height: 34px;
    border: none;
    border-radius: 999px;
    background: transparent;
    color: var(--legal-text);
    font-size: 12px;
    font-weight: 800;
    cursor: pointer;
    transition: all 0.25s ease;
  }

  .terms-language button.active {
    color: white;
    background: var(--legal-primary);
    box-shadow: 0 5px 12px rgba(255, 95, 145, 0.25);
  }

main.terms-container {
  width: min(1100px, calc(100% - 48px)) !important;
  max-width: 1100px !important;
  margin-left: auto !important;
  margin-right: auto !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  background: transparent !important;
}

  .terms-hero {
    padding: 70px 0 40px;
    text-align: center;
  }

  .terms-hero-icon {
    width: 78px;
    height: 78px;
    margin: 0 auto 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    background: linear-gradient(
      135deg,
      var(--legal-primary),
      var(--legal-primary-dark)
    );
    border-radius: 24px;
    font-size: 32px;
    box-shadow:
      0 20px 40px rgba(255, 95, 145, 0.25),
      0 0 0 12px rgba(255, 95, 145, 0.07);
  }

  .terms-hero h1 {
    margin: 0;
    font-size: clamp(35px, 5vw, 54px);
    line-height: 1.12;
    letter-spacing: -1.8px;
  }

  .terms-hero p {
    max-width: 650px;
    margin: 18px auto 0;
    color: var(--legal-text);
    font-size: 17px;
    line-height: 1.75;
  }

  .terms-update {
    margin-top: 17px;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 9px 15px;
    color: var(--legal-primary-dark);
    background: var(--legal-light);
    border-radius: 999px;
    font-size: 13px;
    font-weight: 700;
  }

  .terms-card {
    width: 100%;
  margin: 0 auto 22px;
  padding: 34px 38px;
    background: rgba(255, 255, 255, 0.97);
    border: 1px solid var(--legal-border);
    border-radius: 22px;
    box-shadow: 0 14px 40px rgba(62, 34, 50, 0.07);
    transition:
      transform 0.25s ease,
      box-shadow 0.25s ease;
  }

  .terms-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 18px 48px rgba(62, 34, 50, 0.11);
  }

  .terms-card-header {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-bottom: 18px;
  }

  .terms-section-icon {
    width: 48px;
    height: 48px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--legal-primary);
    background: var(--legal-light);
    border-radius: 15px;
    font-size: 20px;
  }

  .terms-card h2 {
    margin: 0;
    font-size: 21px;
    line-height: 1.3;
  }

  .terms-card p {
    margin: 0;
    color: var(--legal-text);
    font-size: 15px;
    line-height: 1.8;
  }

  .terms-card p,
.terms-card li {
  font-size: 16px;
  line-height: 1.8;
}

  .terms-card ul {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 13px;
  }

  .terms-card li {
    display: flex;
    align-items: flex-start;
    gap: 11px;
    color: var(--legal-text);
    font-size: 15px;
    line-height: 1.65;
  }

  .terms-card li svg {
    flex-shrink: 0;
    margin-top: 4px;
    color: var(--legal-primary);
  }

  .terms-link {
    color: var(--legal-primary-dark);
    font-weight: 700;
    text-decoration: none;
  }

  .terms-link:hover {
    text-decoration: underline;
  }

  .terms-warning {
    border-left: 5px solid #f4b740;
  }

  .terms-actions {
    margin-top: 36px;
    display: flex;
    justify-content: center;
  }

  .terms-back-button {
    min-height: 52px;
    padding: 0 26px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    color: white;
    background: linear-gradient(
      135deg,
      var(--legal-primary),
      var(--legal-primary-dark)
    );
    border-radius: 999px;
    text-decoration: none;
    font-size: 15px;
    font-weight: 800;
    box-shadow: 0 14px 28px rgba(255, 95, 145, 0.26);
    transition: all 0.25s ease;
  }

  .terms-back-button:hover {
    transform: translateY(-3px);
    box-shadow: 0 18px 35px rgba(255, 95, 145, 0.34);
  }

  .terms-footer {
    margin-top: 55px;
    text-align: center;
    color: #928790;
    font-size: 13px;
  }

  @media (max-width: 700px) {
    .terms-header-content,
    .terms-container {
      width: calc(100% - 28px);
    }

    .terms-header-content {
      min-height: 66px;
    }

    .terms-brand {
      font-size: 18px;
    }

    .terms-brand-icon {
      width: 38px;
      height: 38px;
    }

    .terms-hero {
      padding: 50px 0 30px;
    }

    .terms-hero-icon {
      width: 68px;
      height: 68px;
      font-size: 28px;
    }

    .terms-card {
      padding: 23px 20px;
      border-radius: 18px;
    }

    .terms-card-header {
      align-items: flex-start;
    }

    .terms-card h2 {
      font-size: 19px;
    }

    .terms-section-icon {
      width: 43px;
      height: 43px;
    }

    .terms-back-button {
      width: 100%;
    }
  }
`;

const translations = {
  en: {
    title: "Terms and Conditions",
    subtitle:
      "Please read these terms carefully before creating or using your MyHalal account.",
    lastUpdated: "Last updated: July 2026",

    eligibilityTitle: "1. Eligibility",
    eligibilityText:
      "You must be at least 18 years old to create an account and use MyHalal. By registering, you confirm that the information you provide is accurate.",

    conductTitle: "2. User Conduct",
    conductItems: [
      "Provide truthful and accurate profile information.",
      "Treat other members with dignity and respect.",
      "Do not publish harassment, threats, hate speech or inappropriate content.",
      "Do not impersonate another person or create a fraudulent profile.",
      "Do not use MyHalal for illegal or unauthorized activities.",
    ],

    privacyTitle: "3. Privacy and Personal Information",
    privacyText:
      "Your privacy is important to us. Information about how we collect, use and protect your personal data is available in our",
    privacyLink: "Privacy Policy",

    safetyTitle: "4. Safety and User Interactions",
    safetyText:
      "MyHalal provides tools that help users communicate, block accounts and report inappropriate activity. However, users remain responsible for exercising caution when communicating or meeting another person.",

    liabilityTitle: "5. Limitation of Liability",
    liabilityText:
      "MyHalal is not responsible for personal, financial or other damages resulting from interactions between users. You are responsible for your own decisions and communications.",

    updatesTitle: "6. Changes to These Terms",
    updatesText:
      "We may update these terms when necessary. Continued use of the platform after an update means that you accept the revised terms.",

    acceptanceTitle: "7. Acceptance",
    acceptanceText:
      "By creating an account or continuing to use MyHalal, you confirm that you have read, understood and accepted these Terms and Conditions.",

    back: "Return to registration",
    rights: "All rights reserved.",
  },

  fr: {
    title: "Conditions générales",
    subtitle:
      "Veuillez lire attentivement ces conditions avant de créer ou d’utiliser votre compte MyHalal.",
    lastUpdated: "Dernière mise à jour : juillet 2026",

    eligibilityTitle: "1. Admissibilité",
    eligibilityText:
      "Vous devez avoir au moins 18 ans pour créer un compte et utiliser MyHalal. En vous inscrivant, vous confirmez que les informations fournies sont exactes.",

    conductTitle: "2. Comportement des utilisateurs",
    conductItems: [
      "Fournir des informations de profil exactes et véridiques.",
      "Traiter les autres membres avec dignité et respect.",
      "Ne pas publier de harcèlement, de menaces, de discours haineux ou de contenu inapproprié.",
      "Ne pas usurper l’identité d’une autre personne ni créer un faux profil.",
      "Ne pas utiliser MyHalal pour des activités illégales ou non autorisées.",
    ],

    privacyTitle: "3. Vie privée et informations personnelles",
    privacyText:
      "Votre vie privée est importante pour nous. Les informations concernant la collecte, l’utilisation et la protection de vos données personnelles sont disponibles dans notre",
    privacyLink: "Politique de confidentialité",

    safetyTitle: "4. Sécurité et interactions entre utilisateurs",
    safetyText:
      "MyHalal fournit des outils permettant de communiquer, de bloquer des comptes et de signaler un comportement inapproprié. Toutefois, chaque utilisateur doit rester prudent lorsqu’il communique ou rencontre une autre personne.",

    liabilityTitle: "5. Limitation de responsabilité",
    liabilityText:
      "MyHalal n’est pas responsable des dommages personnels, financiers ou autres résultant des interactions entre utilisateurs. Vous restez responsable de vos décisions et de vos communications.",

    updatesTitle: "6. Modification des conditions",
    updatesText:
      "Nous pouvons modifier ces conditions lorsque cela est nécessaire. L’utilisation continue de la plateforme après une mise à jour signifie que vous acceptez les nouvelles conditions.",

    acceptanceTitle: "7. Acceptation",
    acceptanceText:
      "En créant un compte ou en continuant à utiliser MyHalal, vous confirmez avoir lu, compris et accepté les présentes Conditions générales.",

    back: "Retour à l’inscription",
    rights: "Tous droits réservés.",
  },
};

function TermsAndConditions() {
  const { i18n } = useTranslation();

  useEffect(() => {
    const savedLanguage = localStorage.getItem("language");

    if (savedLanguage === "fr" || savedLanguage === "en") {
      i18n.changeLanguage(savedLanguage);
      return;
    }

    const browserLanguage = (
      navigator.language ||
      navigator.userLanguage ||
      "en"
    ).toLowerCase();

    const detectedLanguage = browserLanguage.startsWith("fr")
      ? "fr"
      : "en";

    i18n.changeLanguage(detectedLanguage);
    localStorage.setItem("language", detectedLanguage);
  }, [i18n]);

  const currentLanguage = i18n.language?.startsWith("fr")
    ? "fr"
    : "en";

  const text = translations[currentLanguage];

  const changeLanguage = (language) => {
    i18n.changeLanguage(language);
    localStorage.setItem("language", language);
  };

  return (
    <>
      <style>{styles}</style>

      <div className="terms-page">
        <header className="terms-header">
          <div className="terms-header-content">
            <Link to="/" className="terms-brand">
              <div className="terms-brand-icon">
                <FaFileContract />
              </div>

              <span>
                My<span>Halal</span>
              </span>
            </Link>

            <div className="terms-language">
              <button
                type="button"
                className={currentLanguage === "fr" ? "active" : ""}
                onClick={() => changeLanguage("fr")}
              >
                FR
              </button>

              <button
                type="button"
                className={currentLanguage === "en" ? "active" : ""}
                onClick={() => changeLanguage("en")}
              >
                EN
              </button>
            </div>
          </div>
        </header>

        <main className="terms-container">
          <section className="terms-hero">
            <div className="terms-hero-icon">
              <FaFileContract />
            </div>

            <h1>{text.title}</h1>
            <p>{text.subtitle}</p>

            <div className="terms-update">
              <FaSyncAlt />
              {text.lastUpdated}
            </div>
          </section>

          <section className="terms-card">
            <div className="terms-card-header">
              <div className="terms-section-icon">
                <FaUserCheck />
              </div>

              <h2>{text.eligibilityTitle}</h2>
            </div>

            <p>{text.eligibilityText}</p>
          </section>

          <section className="terms-card">
            <div className="terms-card-header">
              <div className="terms-section-icon">
                <FaHandshake />
              </div>

              <h2>{text.conductTitle}</h2>
            </div>

            <ul>
              {text.conductItems.map((item) => (
                <li key={item}>
                  <FaCheckCircle />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </section>

          <section className="terms-card">
            <div className="terms-card-header">
              <div className="terms-section-icon">
                <FaShieldAlt />
              </div>

              <h2>{text.privacyTitle}</h2>
            </div>

            <p>
              {text.privacyText}{" "}
              <Link to="/privacy" className="terms-link">
                {text.privacyLink}
              </Link>
              .
            </p>
          </section>

          <section className="terms-card">
            <div className="terms-card-header">
              <div className="terms-section-icon">
                <FaShieldAlt />
              </div>

              <h2>{text.safetyTitle}</h2>
            </div>

            <p>{text.safetyText}</p>
          </section>

          <section className="terms-card terms-warning">
            <div className="terms-card-header">
              <div className="terms-section-icon">
                <FaExclamationTriangle />
              </div>

              <h2>{text.liabilityTitle}</h2>
            </div>

            <p>{text.liabilityText}</p>
          </section>

          <section className="terms-card">
            <div className="terms-card-header">
              <div className="terms-section-icon">
                <FaSyncAlt />
              </div>

              <h2>{text.updatesTitle}</h2>
            </div>

            <p>{text.updatesText}</p>
          </section>

          <section className="terms-card">
            <div className="terms-card-header">
              <div className="terms-section-icon">
                <FaCheckCircle />
              </div>

              <h2>{text.acceptanceTitle}</h2>
            </div>

            <p>{text.acceptanceText}</p>
          </section>

          <div className="terms-actions">
            <Link to="/register" className="terms-back-button">
              <FaArrowLeft />
              {text.back}
            </Link>
          </div>

          <footer className="terms-footer">
            © {new Date().getFullYear()} MyHalal. {text.rights}
          </footer>
        </main>
      </div>
    </>
  );
}

export default TermsAndConditions;